import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { TaskViewModel } from '../../../models-views/task.view.model';
import { AppCommon } from '../../../providers/app-common';
import { FormBuilder, Validators } from '@angular/forms';
import { ProjectViewModel } from '../../../models-views/project.view.model';
import { Observable, Observer } from 'rxjs';

interface FileItem {
  id:number
  name: string;
  file: string; // You can store the download URL here
  media_link:number
  type:string
}

@Component({
  selector: 'app-cpd-files',
  standalone: false,
  templateUrl: './cpd-files.component.html',
  styleUrl: './cpd-files.component.scss'
})
export class CpdFilesComponent {

  loggedInUser :any
  projectForm: any
  fileList: FileItem[] = []
  fileListAdd:NzUploadFile[] = []
  scfileList: NzUploadFile[] = []
  @Input('data') data:any;
  @Output() filesChanged = new EventEmitter<any>();
  isVisible = false;
  loading:boolean = true
  constructor(private message: NzMessageService,private vmt : TaskViewModel,private fb: FormBuilder,private vm :ProjectViewModel,) {
     this.loggedInUser = AppCommon.getloggedInObject().user
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'].currentValue) {
      console.log('Input changed:', changes['data'].currentValue);
      // You can react to the new value here
      this.loading = false

     if (this.data) {
        const addFile = this.data.additional_file_details ? [...this.data.additional_file_details] : [];
        const contFile = this.data.contract_file_details ? [...this.data.contract_file_details] : [];

        addFile.forEach(e => e.type = 'Additional');
        contFile.forEach(e => e.type = 'Contract');

        this.fileList = [...addFile, ...contFile];
      }

      this.projectForm = this.fb.group({
        project_client: [this.data.project_client, Validators.required],
        name: [this.data.name, Validators.required],
        description: [this.data.description, Validators.required],
        due_date: [this.data.due_date, Validators.required],
        contract_files: [[] ],
        additional_files: [[]]
      });
      
    }
  }

  downloadFile(item: FileItem): void {
    // In a real application, you would trigger the download here
    // For example, by opening the URL in a new tab or using a download service.
    console.log(item)
    this.message.info(`Downloading ${item.name}`);
    window.open(item.file, '_blank'); // Basic download simulation
  }

  removeFile(item: any): void {
    console.log(item)
    this.fileList = this.fileList.filter((file) => file.id !== item.id);
    // this.message.success(`Removed ${item.name}`);
    // In a real application, you would likely call an API to remove the file.
    this.vmt.parentCpdFilesComponent = this;
    this.vmt.deleteMediaFile(item.id);
  }

  customUploadRequest = (item: any) => {
    return this.vmt.uploadMediaFile(item, this.loggedInUser.id);
   };

 
  fileDeleted(){
    this.filesChanged.emit(true);
  }



   onUploadContractChange(event: any): void {
    console.log('Upload Event:', event);
    
    if (!event || !event.file) {
      console.error('Invalid upload event or missing file data');
      return;
    }
  
    if (event.type === 'success') {
      console.log('File uploaded successfully:', event.file);
      
      // Safely create the file object with null checks
      const file = {
        id: event.file?.response?.id,
        name: event.file?.response?.name || event.file.name,
        file: event.file?.response?.file,
        media_link: event.file?.response?.media_link,
        type: 'Contract'
      };
  
      // Only proceed if we have an ID
      if (file.id) {
        // Update fileList
        this.fileList = [...this.fileList, file];
        
        // Safely update form control
        const contractFilesControl = this.projectForm.get('contract_files');
        if (contractFilesControl) {
          const currentValue = contractFilesControl.value || [];
          contractFilesControl.setValue(
            [...currentValue, file.id],
            { emitEvent: false }
          );
        }
      } else {
        console.error('Upload response missing ID:', event.file.response);
      }
    } else if (event.type === 'error') {
      console.error('File upload failed:', event.file);
    }
  }


  onUploadAdditionalChange(event: any): void {
    console.log('Upload Event:', event);
    
    if (!event || !event.file) {
      console.error('Invalid upload event or missing file data');
      return;
    }
  
    if (event.type === 'success') {
      console.log('File uploaded successfully:', event.file);
      
      // Check if response exists and has required fields
      if (event.file.response?.id) {
        const newFile = {
          id: event.file.response.id,
          name: event.file.response.name || event.file.name,
          file: event.file.response.file,
          media_link: event.file.response.media_link,
          type: 'Additional'
        };
  
        // Update fileList
        this.fileList = [...this.fileList, newFile];
        
        // Update form control safely
        const additionalFilesControl = this.projectForm.get('additional_files');
        if (additionalFilesControl) {
          const currentValue = additionalFilesControl.value || [];
          additionalFilesControl.setValue(
            [...currentValue, event.file.response.id], 
            { emitEvent: false }
          );
        }
      } else {
        console.error('Upload response missing ID:', event.file.response);
      }
    } else if (event.type === 'error') {
      console.error('File upload failed:', event.file);
    }
  }
 
  trackById(index: number, item: any): number {
    return item.id; // or whatever unique identifier your files have
  }
  

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    // console.log('Button ok clicked!');
    this.isVisible = false;
    // generate code fpr update project from form taking additinal and contract file and 
    // also taking existing items from this.data for contract files and additional files
   if (this.projectForm.valid) {
      const dataForm = this.projectForm.value;
      dataForm.created_by = this.loggedInUser.id;

      const additionalFilesFromForm = this.projectForm.get('additional_files')?.value || [];
      const additionalFilesFromData = this.data?.additional_file_details?.map(e => e.id) || [];
      dataForm.additional_files = [...additionalFilesFromForm, ...additionalFilesFromData];

      const contractFilesFromForm = this.projectForm.get('contract_files')?.value || [];
      const contractFilesFromData = this.data?.contract_file_details?.map(e => e.id) || [];
      dataForm.contract_files = [...contractFilesFromForm, ...contractFilesFromData];

      this.vm.parentCpdFilesComponent = this;
      this.vm.updateProject(dataForm, this.data.id, 'app-cpd-files');
    } else {
      this.message.error('Please fill all required fields correctly');
    }

  }

  handleCancel(): void {
    // console.log('Button cancel clicked!');
    this.isVisible = false;
  }

  fileCreated(){
    this.filesChanged.emit(true);
  
  }

    beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> => 
      new Observable((observer: Observer<boolean>) => {
          const isLt5M = file.size! / 1024 / 1024 < 5;
          if (!isLt5M) {
              this.message.error(`${file.name} is larger than 5MB!`);
              observer.next(false); // Emit false to indicate validation failed
              observer.complete();
          } else {
              observer.next(true); // Emit true to indicate validation passed
              observer.complete();
          }
      });


}
